import { render, staticRenderFns } from "./PollBarChartV2.vue?vue&type=template&id=8b1944c8&scoped=true&"
import script from "./PollBarChartV2.vue?vue&type=script&lang=js&"
export * from "./PollBarChartV2.vue?vue&type=script&lang=js&"
import style0 from "./PollBarChartV2.vue?vue&type=style&index=0&id=8b1944c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1944c8",
  null
  
)

export default component.exports